// Curated schema mapping friendly labels to the exact English source strings used across the site.
// The admin edits English + Arabic for each; overrides are keyed by the English source string
// and applied globally through the t() translation layer.

export const CONTENT_SCHEMA = [
  {
    page: "Home",
    groups: [
      {
        title: "Hero",
        fields: [
          ["Capital · Partnerships · Opportunity · Saudi Arabia", "Eyebrow"],
          ["Where Capital, Opportunity & Partnerships Intersect.", "Headline"],
          ["Intersect Holding builds ventures, creates strategic partnerships and connects capital with opportunities across Saudi Arabia and international markets.", "Subtext"],
        ],
      },
      {
        title: "Philosophy",
        fields: [
          ["Intersect Philosophy", "Eyebrow"],
          ["We operate at the intersection of capital, relationships and opportunity.", "Heading"],
          ["Connecting investment capital with credible opportunities.", "Capital card"],
          ["Building, backing and scaling businesses with long-term potential.", "Ventures card"],
          ["Creating commercial alliances that expand capabilities and market access.", "Partnerships card"],
          ["Providing access to one of the world's most dynamic economic transformations.", "Saudi Arabia card"],
        ],
      },
      {
        title: "What We Do",
        fields: [
          ["Investing in ideas with the potential to scale.", "Venture Capital headline"],
          ["Turning opportunities into companies.", "Venture Building headline"],
          ["Relationships that create enterprise value.", "Strategic Partnerships headline"],
          ["Connecting global capability with Saudi opportunity.", "Saudi Expansion headline"],
        ],
      },
      {
        title: "Saudi Opportunity",
        fields: [
          ["A market being built for the next generation.", "Heading"],
          ["Saudi Arabia is undergoing one of the world's most ambitious economic transformations. New industries, investment platforms, technologies and commercial ecosystems are being created across the Kingdom.", "Paragraph 1"],
          ["Intersect identifies where these changes create opportunities for investment, partnerships and new ventures.", "Paragraph 2"],
        ],
      },
      {
        title: "What We Do — Cards",
        fields: [
          ["Venture Capital", "Card 1 label"],
          ["We identify, evaluate and participate in high-potential ventures where strategic capital, Saudi market access and partnership development can accelerate growth.", "Card 1 body"],
          ["Venture Building", "Card 2 label"],
          ["Intersect develops ventures around validated market opportunities, assembling the capital, partnerships, operating capabilities and commercial relationships necessary for growth.", "Card 2 body"],
          ["Strategic Partnerships", "Card 3 label"],
          ["We bring together organizations with complementary capabilities to create strategic alliances, joint ventures and commercial partnerships.", "Card 3 body"],
          ["Saudi Market Expansion", "Card 4 label"],
          ["Intersect works with international companies, investors and innovators seeking strategic relationships, commercial opportunities and long-term participation in the Saudi economy.", "Card 4 body"],
        ],
      },
      {
        title: "Home — Partnerships & CTA",
        fields: [
          ["The right partnership can create an entirely new market.", "Partnerships heading"],
          ["We work across borders and sectors to identify organizations whose capabilities become more valuable when combined.", "Partnerships body"],
          ["Great opportunities often begin with a conversation.", "Final CTA heading"],
          ["Whether you are building a company, exploring Saudi Arabia, seeking investment or looking for the right strategic partner, we would like to hear from you.", "Final CTA body"],
        ],
      },
    ],
  },
  {
    page: "About",
    groups: [
      {
        title: "Hero & Intro",
        fields: [
          ["Building value through capital, relationships and execution.", "Hero title"],
          ["A Saudi investment and strategic holding company.", "Who We Are heading"],
          ["Intersect Holding develops ventures, partnerships and long-term commercial relationships across Saudi Arabia and international markets. We are positioned as an investor, partner, venture builder and originator of opportunity.", "Who We Are paragraph 1"],
          ["We are not a consultancy. We participate, build and hold — creating value where capital, markets, relationships and ideas intersect.", "Who We Are paragraph 2"],
        ],
      },
      {
        title: "Purpose & Philosophy",
        fields: [
          ["Identifying where value can be created.", "Purpose heading"],
          ["Intersect exists to identify points where capital, markets, relationships and ideas can intersect to create new economic value.", "Purpose statement"],
          ["We believe the most valuable companies are built at intersections — where capital meets opportunity, where global capability meets Saudi ambition, and where relationships become partnerships.", "Philosophy paragraph 1"],
          ["Our approach is patient and long-term. We seek durable businesses rather than short-term transactions.", "Philosophy paragraph 2"],
          ["Grounded in Saudi Arabia, connected to the world.", "Global perspective heading"],
          ["Our network spans investors, founders, corporations, family offices and institutions — the relationships that turn opportunities into companies.", "Global perspective body"],
        ],
      },
      {
        title: "Values — Cards",
        fields: [
          ["Long-Term Thinking", "Value 1"],
          ["Relationships", "Value 2"],
          ["Integrity", "Value 3"],
          ["Entrepreneurship", "Value 4"],
          ["Execution", "Value 5"],
          ["Curiosity", "Value 6"],
        ],
      },
    ],
  },
  {
    page: "Investment",
    groups: [
      {
        title: "Hero & Philosophy",
        fields: [
          ["Backing businesses with more than capital.", "Hero title"],
          ["Capital paired with market access, relationships and the ability to execute.", "Hero subtitle"],
          ["Our value beyond capital.", "Philosophy heading"],
          ["We identify, evaluate and participate in high-potential ventures where strategic capital, Saudi market access and partnership development can accelerate growth. Strong companies become stronger when they gain access to the right markets and relationships.", "Philosophy body"],
          ["Where we participate.", "Themes & Stages heading"],
          ["Investment criteria.", "What We Look For heading"],
        ],
      },
      {
        title: "Investment Stages — Cards",
        fields: [
          ["Early Stage", "Stage 1 title"],
          ["Backing founders at the formation of ambitious companies.", "Stage 1 text"],
          ["Growth Stage", "Stage 2 title"],
          ["Supporting proven businesses entering their scaling phase.", "Stage 2 text"],
          ["Strategic Investments", "Stage 3 title"],
          ["Capital paired with market access and relationships.", "Stage 3 text"],
          ["Joint Ventures", "Stage 4 title"],
          ["Co-building new companies around validated opportunities.", "Stage 4 text"],
          ["Corporate Ventures", "Stage 5 title"],
          ["Partnering with corporates to create new business lines.", "Stage 5 text"],
          ["Special Situations", "Stage 6 title"],
          ["Selective participation where structure creates value.", "Stage 6 text"],
        ],
      },
    ],
  },
  {
    page: "Partnerships",
    groups: [
      {
        title: "Hero & Sections",
        fields: [
          ["Some opportunities require more than one company.", "Hero title"],
          ["We bring together organizations whose capabilities become more valuable when combined.", "Hero subtitle"],
          ["Creating alliances that create value.", "Our Role heading"],
          ["Intersect identifies organizations with complementary capabilities and aligns their interests to create strategic alliances, joint ventures and commercial partnerships. We work across borders and sectors — connecting global capability with Saudi opportunity.", "Our Role body"],
          ["The forms partnership can take.", "Partnership Models heading"],
          ["From opportunity to execution.", "Partnership Model flow heading"],
        ],
      },
      {
        title: "Partnership Models — Cards",
        fields: [
          ["Strategic Alliances", "Model 1"],
          ["Joint Ventures", "Model 2"],
          ["Market Partnerships", "Model 3"],
          ["Technology Partnerships", "Model 4"],
          ["Distribution Partnerships", "Model 5"],
          ["Corporate Ventures", "Model 6"],
          ["Investment Partnerships", "Model 7"],
          ["Government & Institutional Collaboration", "Model 8"],
          ["Cross-Border Partnerships", "Model 9"],
        ],
      },
    ],
  },
  {
    page: "Saudi Arabia",
    groups: [
      {
        title: "Hero & Sections",
        fields: [
          ["Saudi Arabia is becoming a platform for global growth.", "Hero title"],
          ["One of the world's most ambitious economic transformations — and a growing intersection of global markets.", "Hero subtitle"],
          ["A Kingdom of expanding centers.", "Centers heading"],
          ["Economic activity is expanding across multiple regions of Saudi Arabia, each developing its own industries and opportunities.", "Centers body"],
          ["Saudi Arabia at the intersection of global markets.", "Global Connection heading"],
        ],
      },
    ],
  },
];

// Named background/decorative images used across the site (keys map to the shared IMG object).
export const MEDIA_LIBRARY = [
  ["heroRiyadh", "Home — Hero background (Riyadh)"],
  ["boardroomView", "Home/About — Boardroom / portrait image"],
  ["skylineSunset", "Skyline sunset (What We Do / About philosophy)"],
  ["cityNight", "City at night (Saudi Opportunity / Saudi hero)"],
  ["kafdAerial", "KAFD aerial (Philosophy / Final CTA / sections)"],
  ["kafdTower", "KAFD tower (Network / About)"],
  ["geometric", "Geometric (Areas We Explore / sections)"],
  ["abstractGold", "Abstract gold (Investment approach / hero)"],
  ["kingdomDay", "Kingdom by day (Investment / Saudi)"],
  ["riyadhHighway", "Riyadh highway (Investment)"],
  ["faisaliah", "Al Faisaliah (Partnerships / Insights preview)"],
  ["jeddahWater", "Jeddah waterfront (Portfolio / Saudi)"],
  ["jeddahCorniche", "Jeddah Corniche"],
  ["madinah", "Madinah (About values)"],
  ["kingdomSunset", "Kingdom sunset"],
  ["riyadhNight", "Riyadh night"],
];
